module.exports = __webpack_public_path__ + "media/images/backgrounds/empty-placeholder-bg-b2133b88da7514a38487430ef7f5c17a.svg";